"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPendingPaymentURLApi = exports.discardPaymentUsableRedisDataApi = exports.savePaymentUsableDataApi = exports.getPaymentUsableDataApi = exports.verifyPaymentApi = exports.getByPaymentNumberApi = exports.orderPaymentByWalletApi = exports.getPaymentByApi = exports.getPaymentByOrderApi = exports.retryPaymentPaystackApi = exports.paymentInitApi = void 0;
const apiPath_1 = require("../apiPath");
const paymentInitApi = async (axiosInstance, form) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.payment.initiate.frontend, form);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.paymentInitApi = paymentInitApi;
const retryPaymentPaystackApi = async (axiosInstance, form) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.payment.paystackRetryPayment.frontend, form);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.retryPaymentPaystackApi = retryPaymentPaystackApi;
const getPaymentByOrderApi = async (axiosInstance, orderId) => {
    try {
        const _data = await axiosInstance.get(`/payment/order/${orderId}`);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getPaymentByOrderApi = getPaymentByOrderApi;
const getPaymentByApi = async (axiosInstance) => {
    try {
        const _data = await axiosInstance.get(`/payment/`);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getPaymentByApi = getPaymentByApi;
const orderPaymentByWalletApi = async (axiosInstance, form) => {
    try {
        const _data = await axiosInstance.post(`/payment/wallet`, form);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.orderPaymentByWalletApi = orderPaymentByWalletApi;
const getByPaymentNumberApi = async (axiosInstance, paymentNumber) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.payment.getByPaymentNumber(paymentNumber).frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getByPaymentNumberApi = getByPaymentNumberApi;
const verifyPaymentApi = async (axiosInstance, paymentNumber) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.payment.verifyPayment(paymentNumber).frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response || error.message;
    }
};
exports.verifyPaymentApi = verifyPaymentApi;
const getPaymentUsableDataApi = async (axiosInstance) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.payment.getPaymentUsableData.frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getPaymentUsableDataApi = getPaymentUsableDataApi;
const savePaymentUsableDataApi = async (axiosInstance) => {
    try {
        const _data = await axiosInstance.put(apiPath_1.API_PATH.payment.savePaymentUsableData.frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.savePaymentUsableDataApi = savePaymentUsableDataApi;
const discardPaymentUsableRedisDataApi = async (axiosInstance) => {
    try {
        const _data = await axiosInstance.put(apiPath_1.API_PATH.payment.discardPaymentUsableRedis.frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.discardPaymentUsableRedisDataApi = discardPaymentUsableRedisDataApi;
const getPendingPaymentURLApi = async (axiosInstance, paymentNumber) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.payment.getPendingPaymentUrl(paymentNumber).frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getPendingPaymentURLApi = getPendingPaymentURLApi;
//# sourceMappingURL=payment.js.map